import { Typography } from '@atlas-metrics/design-system';
import React from 'react';

import clsxm from '@/lib/clsxm';

import {
  ButtonSize,
  ButtonType,
  getButtonSize,
  getButtonVariant,
} from './getButtonStyle';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonType;
  className?: string;
  text: string;
  disabled?: boolean;
  isLoading?: boolean;
  size?: ButtonSize;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const Button: React.FC<ButtonProps> = ({
  className,
  text,
  variant = 'primary',
  disabled,
  isLoading,
  onClick,
  size = 'l',
}) => {
  return (
    <button
      type='button'
      className={clsxm(
        'flex w-full items-center justify-center rounded-2xl border text-m  capitalize',
        getButtonVariant(variant),
        getButtonSize(size),
        className
      )}
      onClick={disabled || isLoading ? undefined : onClick}
    >
      {size === 'l' ? (
        <Typography variant='body-l' className='text-inherit'>
          {text}
        </Typography>
      ) : (
        <Typography variant='body-m' bold className='text-inherit'>
          {text}
        </Typography>
      )}
    </button>
  );
};

export default Button;
